// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 125) return "static/chunks/125-af4e7cdd04c1ccb2.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","541":"4cfcd194"}[chunkId] || chunkId) + "." + {"146":"983a867c9094c2be","298":"3c17f9a45cf5b456","340":"05becb5ede617c33","367":"5040e60c38bf6319","432":"fe519466e301961f","541":"3d1a250473a4adb0","695":"7781d3868a3e0785"}[chunkId] + ".js";
};